import React, { useState } from "react";
import styled from "styled-components";
import WebMap from "./WebMap";
import { graphql, useStaticQuery } from "gatsby";

const MapHeadingWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding: 0.2em 0.5em 0.2em 0.5em;
	color: #fefefe;
	border-radius: 4px 4px 0 0;
	height: 7%;

	select:focus {
		outline: 1px solid #fefefe;
		outline-offset: 2px;
	}
`;

const MapSelectWrapper = styled.div`
	width: 100%;
	height: 80%;
`;

const MapWrapper = styled.div`
	width: 100%;
	height: 93%;
	min-height: 600px;
`;

const MapFooter = styled.div`
	width: 100%;
	height: 7%;
	color: #fefefe;
	border-radius: 0 0 4px 4px;
`;

const query = graphql`
	{
		reappEnvConfig {
			esri {
				portalUrl
			}
		}
	}
`;

const WebMapSelect = ({ header, maps, footer }) => {
	const [mapId, setMapId] = useState(maps[0].id);
	const {
		reappEnvConfig: { esri },
	} = useStaticQuery(query);

	return (
		<MapSelectWrapper className="shadow-sm">
			<MapHeadingWrapper className="bg-dark">
				<header
					id="map-select-heading"
					className="h5 w-100 m-0 p-0 mr-1"
				>
					{header}
				</header>
				{maps.length > 1 ? (
					<select
						title="Select map"
						aria-labelledby="map-select-heading"
						onChange={({ target }) => setMapId(target.value)}
					>
						{maps.map(m => (
							<option key={m.id} value={m.id}>
								{m.name}
							</option>
						))}
					</select>
				) : null}
			</MapHeadingWrapper>
			<MapWrapper>
				<WebMap mapId={mapId} portalUrl={esri.portalUrl} />
			</MapWrapper>
			<MapFooter className="bg-dark">{footer}</MapFooter>
		</MapSelectWrapper>
	);
};

export default WebMapSelect;
